<template>
  <discover searchType="4" />
</template>

<script>
// eslint-disable-next-line import/extensions
import Discover from '@/components/Discover'

export default {
  name: 'OnlineUsers',
  components: {
    Discover,
  },
}
</script>
